import PropTypes from 'prop-types';
import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import Order from '../../../records/Order';
import { translate as t } from '../../../lib/I18n';

import Price from '../../general/Price';
import PaymentCardDetails from '../../payment/PaymentCardDetails';
import PaypalPaymentDetails from '../../payment/PaypalPaymentDetails';
import ApplePayPaymentDetails from '../../payment/ApplePayPaymentDetails';
import GooglePayPaymentDetails from '../../payment/GooglePayPaymentDetails';
import BraintreeCardPaymentDetails from '../../payment/BraintreeCardPaymentDetails';

class PaymentInformation extends React.PureComponent {

    static propTypes = {
        order: PropTypes.instanceOf(Order).isRequired
    };

    renderPaymentDetails (type) {
        const { order } = this.props;

        const cards = order[type].getCards();
        const lightPromoWarrants = order.getLightPromoWarrants(type);
        const eVoucherWarrants = order.getEVoucherWarrants(type);
        const eVoucherAmount = order.getEVoucherPaymentAmount(type);
        const paypalPayment = order.getPaypalPayment(type);
        const applePayPayment = order.getApplePayPayment(type);
        const googlePayPayment = order.getGooglePayPayment(type);
        const braintreeCardPayment = order.getBraintreeCardPayment(type);

        return (
            <Row>
                { lightPromoWarrants.map((warrant, index) => (
                    <div key={`light-promo-${index}`}>
                        <Col xs={ 8 }>{ warrant.campaignName || warrant.campaignCode }</Col>
                        <Col xs={ 4 } className="text-right price"><Price price={ warrant.amount } /></Col>
                    </div>
                )) }
                { eVoucherAmount > 0 &&
                    <div>
                        <Col xs={ 8 }>{ t('account.orders.eVoucherPayment', { count: eVoucherWarrants.size }) }</Col>
                        <Col xs={ 4 } className="text-right price"><Price price={ eVoucherAmount } /></Col>
                    </div> }
                { order.hasCardPayment() && cards.filter((card) => card.amount > 0).map((card, index) =>
                    <div key={ index }>
                        <Col xs={ 8 }><PaymentCardDetails card={ card } /></Col>
                        <Col xs={ 4 } className="text-right price"><Price price={ card.amount } /></Col>
                    </div>
                ) }
                { paypalPayment &&
                    <div>
                        <Col xs={ 8 }><PaypalPaymentDetails payment={ paypalPayment } /></Col>
                        <Col xs={ 4 } className="text-right price"><Price price={ paypalPayment.amount } /></Col>
                    </div> }
                { applePayPayment &&
                    <div>
                        <Col xs={ 8 }><ApplePayPaymentDetails payment={ applePayPayment } /></Col>
                        <Col xs={ 4 } className="text-right price"><Price price={ applePayPayment.amount } /></Col>
                    </div> }
                { googlePayPayment &&
                    <div>
                        <Col xs={ 8 }><GooglePayPaymentDetails payment={ googlePayPayment } /></Col>
                        <Col xs={ 4 } className="text-right price"><Price price={ googlePayPayment.amount } /></Col>
                    </div> }
                { braintreeCardPayment &&
                    <div>
                        <Col xs={ 8 }><BraintreeCardPaymentDetails payment={ braintreeCardPayment } /></Col>
                        <Col xs={ 4 } className="text-right price"><Price price={ braintreeCardPayment.amount } /></Col>
                    </div> }
            </Row>
        );
    }

    render () {
        const { order } = this.props;

        if (!order.isPaid() || order.isFullRefund) {
            return null;
        }

        return (
            <Row>
                <Col xs={ 12 }>
                    <div className="padding-bottom--sm border--bottom">
                        <Row>
                            <Col xs={ 12 }>
                                <h3 className="text-weight--bold">{ t('account.orders.paymentDetails') }</h3>
                            </Col>
                        </Row>
                        <div className="order-summary__payments-wrapper">
                            { this.renderPaymentDetails('payments') }
                            { order.hasChangeoverTickets() && this.renderPaymentDetails('changeoverPayments') }
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }
}

export default PaymentInformation;
